module.exports = __webpack_public_path__ + "img/clientes.223ceec4.svg";